import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { Engagement, EngagementGridContainerPage, EngagementType } from '@interfaces';
import { AppService, BaseEngagementService, DomainDataService } from '../../../../../services';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';

export function getSetup(pageService: BaseEngagementService, util: UtilityService, dialog: DialogService, app: AppService, page: EngagementGridContainerPage | undefined, domainDataService: DomainDataService): GridSetup<Engagement> {
	const engagementType = pageService.engagementType();
	return {
		rowName: { singular: 'Engagement', plural: 'Engagements' },
		getRowKey: row => '' + row.engagementId,
		stateKey: (`${page}-${engagementType}-engagement-grid`).toLowerCase(),
		actions: getActions(pageService, dialog),
		buttons: engagementType === EngagementType.open ? getButtons(pageService, dialog) : [],
		columns: getColumns(util, app, domainDataService),
		renderRowClasses: row => [],
		multiselect: false,
	}
}
